<template>
    <v-container fluid class="pt-0">
        <v-row>
            <v-col cols="12" class="pa-0">
                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
            </v-col>

            <v-col cols="12" lg="3" style="position:relative; top: -60px">
                <v-card>
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-currency-usd</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Ingreso total del mes</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h4">{{ total_month }}{{ month % 1 === 0 ? '.00' : '' }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card class="mt-3">
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-currency-usd</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Ingreso total del día</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h4">{{ total_day }}{{ day % 1 === 0 ? '.00' : '' }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </v-card>

                <v-card class="mt-3">
                    <v-list two-line subheader>
                        <v-list-item>
                            <v-list-item-avatar>
                                <v-icon color="#008dd4" x-large>mdi-account</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content>
                                <v-list-item-title><strong>Total de Alumnos en el mes</strong></v-list-item-title>
                                <v-list-item-subtitle class="text-h4">{{ students.length }}</v-list-item-subtitle>
                            </v-list-item-content>

                        </v-list-item>
                    </v-list>
                </v-card>

                <v-btn class="mt-3" color="success" @click="monthly_payments" block>reporte por fecha</v-btn>
            </v-col>

            <v-col cols="12" lg="9" style="position:relative; top: -60px">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :footer-props="footer_props"
                        :loading-text="loading_text"
                        :no-data-text="no_data_text"
                        :no-results-text="no_result_text"
                        :search="search"
                    >
                        <template v-slot:top>
                            <v-container class="py-0">
                                <v-row align="center" justify="end">
                                    <v-col cols="12" lg="6">
                                        <v-text-field
                                            v-model="search"
                                            clearable
                                            dense
                                            outlined
                                            hide-details
                                            label="Buscar"
                                            append-icon="mdi-magnify"
                                            color="#818181"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </template>
                        <template v-slot:item.proof_image="{ item }">
                            <v-avatar>
                                <v-img :src="images_url+item.proof" @click="() => { show_image_item = item.proof; show_proof_image = true}" style="cursor:pointer"></v-img>
                            </v-avatar>
                        </template>

                        <template v-slot:item.validated="{ item }">
                            <v-chip v-if="item.validated == 1 && item.status == 0" color="green" text-color="white">Validado</v-chip>
                            <v-chip v-else-if="!item.validated && item.status == 1" color="primary" text-color="white">Pendiente</v-chip>
                            <v-chip v-else color="red" text-color="white">Rechazado</v-chip>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-menu offset-y>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on">
                                        <v-icon>mdi-menu</v-icon>
                                    </v-btn>
                                </template>
                                <v-list dense>
                                    <v-list-item v-if="!item.validated && item.status == 1" class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="validateDialog(item)">Validar</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="!item.validated && item.status == 1" class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="refuseDialog(item)">Rechazar</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item v-if="!item.validated && !item.status" class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="refuseReport(item)">Reporte de rechazo</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text @click="student(item)">Alumno</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-list-item class="px-0">
                                        <v-list-item-content>
                                            <v-btn small text>Eliminar</v-btn>
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="validate_dialog" persistent scrollable width="800">
            <v-card>
                <v-card-title class="headline primary white--text">Validar comprobante</v-card-title>
                <v-card-text class="mt-4">
                    <v-simple-table>
                        <template v-slot:default>
                            <tbody>
                                <tr>
                                    <td>Folio</td>
                                    <td>{{ selected_proof.folio }}</td>
                                </tr>
                                <tr>
                                    <td>Cantidad ingresada</td>
                                    <td><strong>${{ selected_proof.quantity }}</strong></td>
                                </tr>
                                <tr>
                                    <td>Fecha</td>
                                    <td><strong>{{ selected_proof.date }}</strong></td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <v-text-field v-model="reference" :error-messages="reference_msg" class="mt-4" filled color="#000" label="Referencia"></v-text-field>
                    <v-img class="mt-4" :src="images_url+selected_proof.proof"></v-img>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="validate_dialog = false" :disabled="btn_loading">Cancelar</v-btn>
                    <v-btn color="primary" class="px-5" :loading="btn_loading" @click="validate(selected_proof)">validar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="refuse_dialog" persistent width="800">
            <v-card>
                <v-form v-model="refuse_form" ref="refuse_form" v-on:submit.prevent="refuse(selected_proof)">
                    <v-card-title class="headline primary white--text">Rechazar comprobante</v-card-title>
                    <v-card-text class="mt-4">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="reason" filled color="#000" :rules="[rules.required]" label="Motivo"></v-text-field>
                                    <v-switch v-model="disable_user" label="Deshabilitar usuario"></v-switch>
                                    <v-img :src="images_url+selected_proof.proof"></v-img>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="#000" @click="cancel" :disabled="btn_loading">Cancelar</v-btn>
                        <v-btn color="primary" class="px-5" :loading="btn_loading" type="submit">Rechazar comprobante</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>

        <v-dialog v-model="refuse_report_dialog" persistent scrollable width="800">
            <v-card v-if="selected_proof.refuse">
                <v-card-title class="headline primary white--text">Reporte de rechazo</v-card-title>
                <v-card-text class="mt-4">
                    <v-container>
                        <v-row>
                            <v-col cols="12">
                                <h3 class="mb-2">Fecha de alta : <strong>{{ selected_proof.date }}</strong></h3>
                                <h3 class="mb-2">Cantidad : <strong>${{ selected_proof.quantity }}</strong></h3>
                                <h3 class="mb-2" :key="index">Fecha de rechazo : <strong>{{ selected_proof.refuse.date }}</strong></h3>
                                <h3 class="mb-3" :key="index">Motivo : <strong>{{ selected_proof.refuse.reason }}</strong></h3>
                                <v-img :src="images_url+selected_proof.proof"></v-img>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#000" @click="refuse_report_dialog = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="show_proof_image" persistent scrollable width="800">
            <v-card>
                <v-card-title class="headline primary white--text">Comprobante</v-card-title>
                <v-card-text>
                    <v-img :src="images_url+show_image_item" fluid></v-img>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="show_proof_image = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="student_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
            <v-card v-if="student_item">
                <v-toolbar flat color="#008dd4" dark>
                    <v-btn icon @click="student_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>{{ student_item.fullname }}</v-toolbar-title>
                </v-toolbar>
                <v-card-text class="px-0">
                    <v-container class="pt-0" fluid>
                        <v-row class="pa-0" justify="center" align="center">
                            <v-col cols="12" class="pa-0">
                                <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
                            </v-col>

                            <v-col cols="10" class="px-10" style="position:relative; top: -60px">
                                <v-card>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>Correo electrónico</th>
                                                    <th>Balance</th>
                                                    <th>Curso actual</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{{ student_item.email }}</td>
                                                    <td>{{ "$"+student_item.balance.balance }}</td>
                                                    <td>{{ student_item.student_course.course ? student_item.student_course.course.name : 'No seleccionado' }}</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card>

                                <v-card class="mt-3">
                                    <v-data-table
                                        :headers="student_headers"
                                        :items="student_item.payments"
                                        :loading="loading"
                                        :footer-props="footer_props"
                                        :loading-text="loading_text"
                                        :no-data-text="no_data_text"
                                        :no-results-text="no_result_text"
                                        :search="search"
                                    >
                                        <template v-slot:item.proof="{ item }">
                                            <v-btn v-if="item.proof" icon @click="() => { proof_name = item.proof.proof; proof_dialog = true }">
                                                <v-icon>mdi-image</v-icon>
                                            </v-btn>
                                            <span v-else>N/A</span>
                                        </template>

                                        <template v-slot:item.quantity="{ item }">
                                            <span class="red--text darken-1" v-if="item.quantity > 0">0</span>
                                            <span class="red--text darken-1" v-else>{{ item.quantity }}</span>
                                        </template>

                                        <template v-slot:item.payment="{ item }">
                                            <span class="green--text darken-1" v-if="item.verified == 1 || item.type == 'Account Deposit'">{{ Math.abs(item.quantity) }}</span>
                                            <span class="green--text darken-1" v-else>0</span>
                                        </template>

                                        <template v-slot:item.status="{ item }">
                                            <v-chip v-if="item.status > 0" color="red" text-color="white">Pendiente</v-chip>
                                            <v-chip v-else-if="item.type == 'Promotion'" color="primary">Promocíon</v-chip>
                                            <v-chip v-else-if="item.type == 'Account Deposit'" color="secondary">Abono a cuenta</v-chip>
                                            <v-chip v-else color="success">Pago correcto</v-chip>
                                        </template>
                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="proof_dialog" fullscreen>
            <v-card>
                <v-card-title>Comprobante</v-card-title>
                <v-card-text>
                    <v-img v-if="proof_name" :src="proof_url+proof_name"></v-img>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="proof_dialog = false">Cerrar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="monthy_payments_dialog" hide-overlay transition="dialog-bottom-transition" fullscreen>
            <v-card>
                <v-toolbar flat color="#008dd4" dark>
                    <v-btn icon @click="monthy_payments_dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Reporte mensual</v-toolbar-title>
                </v-toolbar>
               
                <v-container class="py-0" fluid>
                    <v-row justify="center" align="center">
                        <v-col cols="12" class="pa-0">
                            <v-sheet class="" color="#008dd4" height="10vh"></v-sheet>
                        </v-col>
                        <v-col cols="12" lg="8" style="position:relative; margin-top: -60px">
                            <v-card outlined>
                                <v-card-title>Fecha</v-card-title>
                                <v-card-subtitle>Seleccione la fecha de reporte</v-card-subtitle>
                                <v-card-text>
                                    <v-text-field v-model="initial_date" type="date" filled label="Fecha inicial"></v-text-field>
                                    <v-text-field v-model="final_date" type="date" filled label="Fecha final"></v-text-field>
                                    <v-btn color="primary" @click="monthly_payments">Seleccionar</v-btn>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="12" lg="8" class="mt-1">
                            <v-card outlined>
                                <v-card-subtitle>Resultado</v-card-subtitle>
                                <v-divider></v-divider>
                                <v-row class="px-4">
                                    <template v-for="(date, index) in current_month_payments">
                                        <v-col :key="index" cols="12" lg="2">
                                            <v-card :key="index" outlined>
                                                <v-card-text class="text-center">
                                                    {{ date.date }}
                                                    <v-divider></v-divider>
                                                    <span class="mt-1">
                                                        <strong>
                                                            ${{ date.quantity }}
                                                        </strong>
                                                    </span>
                                                </v-card-text>
                                            </v-card>
                                        </v-col>
                                    </template>
                                </v-row>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
               
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>

import iziToast from 'izitoast'

export default {
    props:['proofs','month','day', 'students'],
    data: () => ({
        //props
        items:[],
        images_url:"/storage/payment_proofs/",
        validate_url:"/invoices/validate",
        refuse_url:"/invoices/refuse",
        selected_proof:"",
        btn_loading:false,
        validate_dialog:false,
        quantity_month:"",
        quantity_daily:"",

        //student dialog
        student_dialog:false,
        proof_dialog:false,
        proof_name:"",
        store_proof_url:"/students/store_proof",
        proof_url:"/storage/payment_proofs/",
        student_item:"",

        show_proof_image:false,
        refuse_report_dialog:false,
        refuse_dialog:false,
        monthy_payments_dialog:false,
        refuse_form:false,

        show_image_item:"",
        reference:"",
        reference_msg:"",

        disable_user:false,
        reason:"",


        //MONTHLY PAYMENTS REPORT
        current_month_payments:"",
        date_loading:"",
        initial_date:"",
        final_date:"",

        //data table props
        color:"#818181",
        search:"",
        loading:"#008dd4",
        loading_text:"Cargando...",
        no_data_text:"Sin elementos registrados",
        no_result_text:"Sin coincidencias",
        headers:[
            { text:'ID', value:'id' },
            { text:'Fecha', value:'date' },
            { text:'Estudiante', value:'student.fullname' },
            { text:'Referencia', value:'reference' },
            { text:'Cantidad', value:'quantity' },
            { text:'Comprobante', value:'proof_image'},
            { text:'Estado', value:'validated' },
            { text: 'Acciones', value:'actions', sorteable:false}
        ],
        footer_props:{
            itemsPerPageText:"Filas por página",
            showCurrentPage:true,
            itemsPerPageAllText:"Todo"
        },

        //data table props
        
        student_search:"",
        student_headers:[
            { text:'Folio', value:'id' },
            { text:'Fecha', value:'date' },
            { text:'Concepto', value:'description' },
            { text:'Comprobante', value:'proof'},
            { text:'Cantidad', value:'quantity'},
            { text:'Abono', value:'payment' },
            { text:'Estado', value:'status' },
        ],

        rules:{
            required: v => !!v || 'El campo es requerido',
        },
    }),

    created(){
        if(this.proofs.length > 0){
            this.items = this.proofs
        }

        this.quantity_month = this.month
        this.quantity_daily = this.day

        this.loading = false
    },

    computed:{
        total_month:function(){
            return this.quantity_month.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        total_day:function(){
            return this.quantity_daily.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    },

    methods:{
        validateDialog: function(item){
            this.selected_proof  = item
            this.validate_dialog = true
        },

        validate:function(proof){
            if(this.reference === ""){
                this.reference_msg = "Ingrese la referencia"
                return
            }

            this.btn_loading = true
            let data = {}
            data.proof_id  = proof.id
            data.validate  = true
            data.reference = this.reference

            axios.post(this.validate_url, data).then(response => {
                this.items = response.data.proofs
                this.quantity_month = response.data.month
                this.quantity_daily = response.data.day
                this.validate_dialog = false

                iziToast.success({
                    position:'topRight',
                    title:'Correcto',
                    message:'Comprobante validado correctamente'
                })

                this.reference_msg = this.reference = ""
                this.btn_loading = false

            }).catch(error => {
                if(error.response.data.reference){
                    iziToast.error({
                        position:'topRight',
                        title:"Error",
                        message:"La referencia ya fue registrada anteriormente"
                    })
                }else{
                    iziToast.error({
                        position:'topRight',
                        title:"Error",
                        message:"Error en la comunicación con el servidor"
                    })
                }
            })
        },

        refuseDialog:function(item){
            this.selected_proof = item
            this.refuse_dialog  = true
        },

        refuse:function(proof){
            if(this.$refs.refuse_form.validate()){
                this.btn_loading = true
                let data = {}
                data.proof_id = proof.id
                data.disable_user = this.disable_user
                data.reason = this.reason

                axios.post(this.refuse_url, data).then(response => {
                    this.items = response.data.proofs
                    this.quantity_month = response.data.month
                    this.quantity_daily = response.data.day
                    this.cancel()

                    iziToast.success({
                        position:'topRight',
                        title:'Correcto',
                        message:'El comprobante ha sido rechazado'
                    })
                }).then(error => {})
            }
        },

        refuseReport:function(item){
            this.selected_proof = item
            this.refuse_report_dialog = true
        },

        cancel:function(){
            this.selected_proof = ""
            this.refuse_dialog = false
            this.$refs.refuse_form.reset()
            this.btn_loading = false
        },

        student:function(item)
        {
            axios.get('/invoices', {params:{ ajax:true, student_id:item.student.id }}).then(response => {
                this.student_item = response.data.student
                this.student_dialog = true
            }).catch(error => {
                console.log(error)
            })
        },

        monthly_payments:function()
        {   
            axios.get('/invoices/proof_by_date',{ params:{ ajax:true, initial_date: this.initial_date, final_date:this.final_date } }).then(response => {
                this.current_month_payments = response.data.current_month
                this.monthy_payments_dialog = true
            }).catch(error => {
                console.log(error)
            })
        }
    }
}
</script>
